import { useContext } from "react";
import CustomModal from "../CustomModal/CustomModal";
import styles from "./PlaceholderTemplate.module.css";
import { PlaceholderPreview } from "../../apps/Bundles/Placeholder/PlaceholderBundle/PlaceholderBundle";
import { PlaceholderContext } from "../../apps/Bundles/Placeholder/Placeholder";
import { PlaceholderTemplateInfo } from "../TemplateSelectionScreen/TemplateSelectionConstants";
import { AppConfigContext } from "../../context/AppConfigContext";

const PlaceholderTemplate = ({
    setOpenBBTemplateModal,
    bundleConfig,
    dispatchBundleConfig,
}: {
    openBBTemplateModal: any;
    setOpenBBTemplateModal: any;
    bundleConfig: any;
    dispatchBundleConfig: any;
}) => {
    const appConfigContext = useContext(AppConfigContext);
    const placeholderContext = useContext(PlaceholderContext);

    const handleChangeSelectedTemplate = (template: string) => {
        dispatchBundleConfig({
            payload: template,
            key: "selected_template_placeholder",
        });

        placeholderContext?.fields?.selected_template_placeholder?.onChange(template);
        setOpenBBTemplateModal(false);
    };

    return (
        <CustomModal
            title="Choose a Template"
            onClose={() => setOpenBBTemplateModal(false)}
            open={true}
            primaryAction={{
                content: "Close",
                onAction: () => setOpenBBTemplateModal(false),
            }}
            size="large"
        >
            <div className={styles.mainContainer}>
                {PlaceholderTemplateInfo.map((t) => {
                    const isSelected = bundleConfig.selected_template_placeholder === t.template;
                    return (
                        <div
                            className={`${styles.container} ${isSelected ? styles.containerSelected : ""}`}
                            key={t.template}
                        >
                            <div className={styles.previewWrapper}>
                                <div
                                    className={`${styles.checkboxWrapper} ${isSelected ? styles.checkboxSelected : ""}`}
                                    onClick={() => handleChangeSelectedTemplate(t.template)}
                                >
                                    {isSelected && (
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <path
                                                d="M2.5 7L5.5 10L11.5 4"
                                                stroke="currentColor"
                                                strokeWidth="2.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )}
                                </div>
                                <div
                                    style={{
                                        transform: "scale(0.9)",
                                        transformOrigin: "top center",
                                        padding: "40px 10px",
                                    }}
                                >
                                    <PlaceholderPreview
                                        bundleConfig={{
                                            ...bundleConfig,
                                            selected_template_placeholder: t.template,
                                        }}
                                        standAlone={false}
                                        appConfigContext={appConfigContext}
                                        previewType={1}
                                        targetForm={null}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </CustomModal>
    );
};

export default PlaceholderTemplate;
